/** Asks the setup gate to (re)check and open the dialog (used by the Getting started panel). */
export const OWNER_SETUP_OPEN_EVENT = 'owner-setup:open';
/** Fired after the owner finishes the setup so the checklist can refresh. */
export const OWNER_SETUP_COMPLETED_EVENT = 'owner-setup:completed';

/**
 * The product tour waits for the mandatory channel setup so the two never fight for attention:
 * setup first, then the tour. Resolves once the gate has decided there is nothing to ask, or the
 * owner has completed the setup.
 */
let resolveGate: () => void = () => undefined;
let gatePromise: Promise<void> = Promise.resolve();

export const beginOwnerSetupGate = (): void => {
  gatePromise = new Promise<void>((resolve) => {
    resolveGate = resolve;
  });
};

export const settleOwnerSetupGate = (): void => resolveGate();

/** No timeout here on purpose: the setup is mandatory and the owner may take as long as they need. */
export const waitForOwnerSetupGate = (): Promise<void> => gatePromise;
